/** @format */

import React, { useCallback } from 'react';
import {
	StatusButtonContainer,
	AvatarContainer,
	StatusWrapper,
	SpinImg
} from '../styles';
import avatar from '../../../../../images/img/avatar.svg';
import plusBtn from '../../../../../images/img/plus.svg';
import loading from '../../../../../images/img/loading.svg';
import { Trans } from 'react-i18next';
import { getLocalStorageLng } from 'utils/utils';
import { useHistory } from 'react-router-dom';
import { useModal } from '../../../../modules/ui';

const StatusButton = ({
	RWD,
	status,
	createStatus,
	pending,
	handleCreateMeetup
}) => {
	const history = useHistory();
	const { boundToggleRightSidebar } = useModal();
	const localizedLang = getLocalStorageLng();
	const i18nKey = status ? 'createMeetup.title' : 'login_signup.title';

	const redirect = useCallback(() => {
		if (createStatus === 'pending' || pending) {
			return;
		}
		if (status) {
			handleCreateMeetup();
		} else {
			boundToggleRightSidebar(false);
			history.push(`/${localizedLang}/login`);
		}
	}, [localizedLang, handleCreateMeetup, status]);

	return (
		<StatusButtonContainer onClick={redirect}>
			{RWD !== 'MD' && RWD !== 'SM' && (
				<StatusWrapper>
					<Trans i18nKey={i18nKey} />
				</StatusWrapper>
			)}
			<AvatarContainer status={status}>
				{status && (createStatus === 'pending' || pending) && (
					<SpinImg src={loading} width={30} height={30} />
				)}
				{!status && <img src={avatar} width={30} height={30} />}
				{status && createStatus !== 'pending' && !pending && (
					<img src={plusBtn} width={10} height={10} />
				)}
			</AvatarContainer>
		</StatusButtonContainer>
	);
};

export default React.memo(StatusButton);
